export default __webpack_public_path__ + "static/media/portrait9.679192bc.JPG";